import React, { useState, useEffect } from 'react';
import Sidebar from './components/Sidebar';
import Header from './components/Header';

const DRAWER_WIDTH = 250;
const COLLAPSED_WIDTH = 70;

const DashboardLayout = ({ children, session, translation, lang }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false); // For mobile drawer
  const [collapsed, setCollapsed] = useState(false); // For desktop sidebar collapse
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 992);
      if (window.innerWidth >= 992) {
        setSidebarOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleDrawerToggle = () => {
    if (isMobile) {
      setSidebarOpen(!sidebarOpen);
    } else {
      setCollapsed(!collapsed);
    }
  };

  const currentSidebarWidth = collapsed ? COLLAPSED_WIDTH : DRAWER_WIDTH;

  return (
    <>
      <style>
        {`
          .dashboard-layout {
            min-height: 100vh;
            background-color: #f5f6f8;
          }

          .main-content {
            margin-left: ${isMobile ? '0' : currentSidebarWidth + 'px'};
            padding-top: 70px;
            min-height: 100vh;
            transition: margin-left 0.3s ease;
            display: flex;
            flex-direction: column;
          }

          .page-content {
            padding: 20px;
            flex: 1;
          }

          @media (max-width: 991px) {
            .main-content {
              margin-left: 0;
            }
          }
        `}
      </style>

      <div className="dashboard-layout">
        {/* Header */}
        <Header
          drawerWidth={DRAWER_WIDTH}
          collapsedWidth={COLLAPSED_WIDTH}
          onDrawerToggle={handleDrawerToggle}
          isMobile={isMobile}
          collapsed={collapsed}
          session={session}
        />

        {/* Sidebar */}
        <Sidebar
          drawerWidth={DRAWER_WIDTH}
          collapsedWidth={COLLAPSED_WIDTH}
          open={sidebarOpen}
          onClose={() => setSidebarOpen(false)}
          isMobile={isMobile}
          collapsed={collapsed}
          session={session}
        />

        {/* Main Content */}
        <main className="main-content">
          <div className="page-content">
            {children}
          </div>
        </main>
      </div>
    </>
  );
};

export default DashboardLayout;
